export default "/assets/images/mila-icon.png?83751125a8c1b023f5ccbae93b7abf15";